<template>
  <div class="costContainer" v-loading="loading">
    <div class="headerCon">
      <div class="left">
        <van-icon name="arrow-left" @click="$router.replace('/insuranceHome')" />
      </div>
      <div class="headerTit">关联子女申报查询</div>
      <div class="right"></div>
    </div>
    <div class="selectCon">
      <el-select v-model="value" placeholder="请选择" size="medium" @change="chnageChildName">
        <el-option v-for="item in childrenNameList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="costContent">
      <van-cell-group>
        <van-field v-model="name" label="员工姓名" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="isInsured" label="是否为子女参保" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="childName" label="投保子女姓名" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="gender" label="投保子女性别" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="idType" label="投保子女证件类型" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="idNumber" label="投保子女证件号" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="birthDate" label="投保子女出生日期" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="isMarried" label="投保子女婚否" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="isStudent" label="投保子女是否在校生" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="schoolCity" label="投保子女学校城市" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="schoolName" label="投保子女学校名称" readonly input-align="right" label-width="160px" v-if="isInsured != '否'"/>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/insurance.js";
import moment from "moment";
import "moment/locale/zh-cn";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "commercialQuery",
  data() {
    return {
      childrenNameList: [],
      value: "",
      carInfo: {
        peopleNum: "",
        marker: ""
      },
      name: "", //姓名
      empno: "", //工号
      isInsured: "", //是否为子女参保
      childName: "", //投保子女姓名
      gender: "", //性别
      idType: "", //证件类型
      idNumber: "", //证件号
      birthDate: "", //出生日期
      isShowBirthdate: false,
      BirthdateTime: "",
      isMarried: "", //是否结婚
      isStudent: "", //投保子女是否在校生
      schoolCity: "", // 学校城市
      schoolName: "", // 学校
      cityCode: "", // 城市编码
      loading: false
    };
  },

  mounted() {
    // this.name =
    //   JSON.parse(localStorage.getItem("store")).userInfo.userid +
    //   "/" +
    //   JSON.parse(localStorage.getItem("store")).userInfo.nickname;
    // this.queryEmployeeChild();
    let token = getToken();
    if (token) {
      this.queryEmployeeChild();
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.queryEmployeeChild();
        });
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;

            this.empno = info.empNo;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 获取子女投保信息
    queryEmployeeChild() {
      const json = {
        empno: getToken(),
        page: 1,
        pageSize: 1000,
        filterPolicyStatus: '失效'
      };
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          if (getToken()) {
            this.empno = getToken();
          } else {
            this.getHrToken(getToken());
          }
          this.childrenNameList = res.data.map(item => {
            return {
              label: item.childName,
              value: item.idNumber,
            };
          });
          this.value = this.childrenNameList.length > 0 ? this.childrenNameList[0].value : '';
          console.log('this.value', this.value);
          if (this.value) {
            this.querInfo();
          } else {
            this.queryUser(getToken());
          }

        }
      });
    },
    // 获取用户信息
    queryUser(token) {
      apis.queryByUsernames({ username: token }).then(res => {
        if (res.code == 200) {
          this.name =
            res.data.userid +
            "/" +
            res.data.nickname;
          this.isInsured = '否';
        }
      });
    },
    // 获取子女投保信息
    querInfo() {
      const json = {
        empno: getToken(),
        keywords: this.value,
        page: 1,
        pageSize: 1000,
        filterPolicyStatus: '失效'
      };
      this.loading = true;
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          console.log("res11", res.data);

          this.name = res.data.length > 0 ? res.data[0].empno + '/' + res.data[0].employeeName : '', //姓名
            //   this.empno = res.data[0].empno, //工号
            this.isInsured = res.data.length > 0 && res.data[0].isInsured == true ? '是' : res.data.length > 0 && res.data[0].isInsured == false ? '否' : '', //是否为子女参保
            this.childName = res.data.length > 0 ? res.data[0].childName : '', //投保子女姓名
            this.gender = res.data.length > 0 && res.data[0].gender == 1 ? '男' : res.data.length > 0 && res.data[0].gender == 2 ? '女' : '', //性别
            this.idType = res.data.length > 0 ? res.data[0].idType : '', //证件类型
            this.idNumber = res.data.length > 0 ? res.data[0].idNumber : '', //证件号
            this.birthDate = res.data.length > 0 && res.data[0].birthDate ? moment(res.data[0].birthDate).format(
              "YYYY-MM-DD"
            ) : null, //出生日期
            this.BirthdateTime = res.data.length > 0 && res.data[0].birthDate ? new Date(res.data[0].birthDate) : null,
            this.isMarried = res.data.length > 0 && res.data[0].isMarried == 1 ? '是' : res.data.length > 0 && res.data[0].isMarried == 0 ? '否' : '', //是否结婚
            this.isStudent = res.data.length > 0 && res.data[0].isStudent == 1 ? '是' : res.data.length > 0 && res.data[0].isStudent == 0 ? '否' : '', //投保子女是否在校生
            this.schoolCity = res.data.length > 0 ? res.data[0].schoolCity : '', // 学校城市
            this.schoolName = res.data.length > 0 ? res.data[0].schoolName : '', // 学校
            this.cityCode = res.data.length > 0 ? res.data[0].cityCode : '';
          if (this.idNumber && !this.birthDate) {
            let birthday = "";
            let time = '';
            birthday = this.idNumber.substr(6, 8);
            time = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
            console.log('time111', time);
            this.birthDate = time;
            this.BirthdateTime = new Date(time);
          }
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 选择子女姓名
    chnageChildName() {
      this.gender = '';
      this.idType = '';
      this.childName = '';
      this.idNumber = '';
      this.birthDate = '';
      this.BirthdateTime = '';
      this.isMarried = '';
      this.isStudent = '';
      this.schoolCity = '';
      this.schoolName = '';
      this.cityCode = '';
      this.querInfo();
    }

  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

.costContainer {
  padding-top: 20px;

  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282b32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    height: 112px;
    background-color: #fff;
    margin-bottom: 20px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;

    .el-select {
      margin-left: 20px;
      width: 180px;
    }

    // .el-input__inner {
    //   height: 70px !important;
    //   line-height: 70px !important;
    // }
  }

  .costContent {
    height: calc(100vh - 222px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }
}
</style>
